import { apiGet, apiPut } from '../utils/apiClient';

export default class UserDataTypeIntegration {
    listUserDataTypes(botApiUrl, templateId, authToken) {
        return apiGet(
            `${botApiUrl}/bot-templates/${templateId}/userdatatypes`,
            { authToken }
        );
    }

    putUserDataTypes(botApiUrl, templateId, templateUserData, authToken) {
        return apiPut(
            `${botApiUrl}/bot-templates/${templateId}/userdatatypes`,
            templateUserData,
            { authToken }
        ).then(() => ({ success: true }));
    }
}
